import React, { FC } from 'react'
// @ts-ignore
import { BrowserRouter } from 'react-router-dom'
// @ts-ignore
import { HashLink } from 'react-router-hash-link'
import { FinancialStrengthProps } from './FinancialStrength.types'
import './FinancialStrength.scss'
import { sanitizeHTML, utilizeScroll } from '../../utils/common-utils'

export const FinancialStrength: FC<FinancialStrengthProps> = props => {
  const { content } = props
  const {
    backgroundImageUrl,
    boxOneHeading,
    boxOneLeftContent,
    boxOneRightContent,
    boxTwoLeftContent,
    boxTwoRightContent,
    boxThreeContent,
    sourceInfoText,
    sourceInfoUrl,
  } = content

  return (
    <BrowserRouter>
      <div className='u-adel-reset financial-strength' id='financial-strength'>
        <div className='Content'>
          <div
            className='u-paddingVert15gu u-sm-paddingVert8gu u-bgSizeCover'
            style={{
              backgroundImage: `url(${backgroundImageUrl})`,
            }}>
            <div className='u-sizeConstrained fs-box'>
              <div className='Content Content--reversed'>
                <div className='u-flexCol u-md-flexCol u-sm-flexCol u-marginTop15gu u-paddingHoriz8gu u-paddingVert10gu u-sm-paddingHoriz2gu'>
                  <div>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: sanitizeHTML(boxOneHeading),
                      }}></div>
                    <div className='border-bottom u-flex u-md-flexCol u-sm-flexCol u-paddingBottom6gu u-md-paddingBottom0 u-sm-paddingBottom0'>
                      <div className='u-size1of2 u-md-sizeFull u-sm-sizeFull'>
                        {boxOneLeftContent && (
                          <div className='u-flex u-flexCol u-flexAlignItemsCenter'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: sanitizeHTML(boxOneLeftContent),
                              }}
                            />
                          </div>
                        )}
                      </div>
                      <div className='u-size1of2 u-md-sizeFull u-sm-sizeFull'>
                        {boxOneRightContent && (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: sanitizeHTML(boxOneRightContent),
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className='u-flex u-md-flexCol u-sm-flexCol u-marginBottom4gu'>
                    <div className='returns-container u-flex u-sm-flexCol u-marginVert5gu'>
                      <div className='returns-content border-md-right u-paddingRight8gu u-sm-paddingRight0 u-sm-paddingBottom4gu'>
                        {boxTwoLeftContent && (
                          <div
                            className=''
                            dangerouslySetInnerHTML={{
                              __html: sanitizeHTML(boxTwoLeftContent),
                            }}
                          />
                        )}
                      </div>
                      <div className='returns-content u-paddingLeft8gu u-sm-paddingLeft0 u-sm-paddingTop4gu'>
                        {boxTwoRightContent && (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: sanitizeHTML(boxTwoRightContent),
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  {boxThreeContent && (
                    <div
                      className='u-padding4gu'
                      dangerouslySetInnerHTML={{
                        __html: sanitizeHTML(boxThreeContent),
                      }}
                    />
                  )}
                </div>
                <div className='u-flex u-flexJustifyEnd u-paddingVert4gu'>
                  <HashLink
                    className='u-md-textSizeMsrp2 u-sm-textSizeMsrp2 u-textSizeMsrp2'
                    scroll={(el: any) => utilizeScroll(`#${sourceInfoUrl}`, 100)}
                    to={`#${sourceInfoUrl}`}>
                    {sourceInfoText}
                  </HashLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BrowserRouter>
  )
}
